import 'bootstrap/dist/css/bootstrap.min.css';
import './message.css'
import React, { useState, useEffect, } from 'react';
import { Container, Row, Col, Nav, Button } from 'react-bootstrap';

function Header({ loginInfo, onHeaderItemSelected, onCheckLogin }) {

    const [isLogin, setIsLogin] = useState(false);  // 是否已登录

    useEffect(() => {        
        if(loginInfo) {
            setIsLogin(loginInfo.islogin);
        }
        
    }, [loginInfo]);

    

    return (
      <header className="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
        <Container>
            <Row>
                <Col className="d-flex align-items-center mb-3 mb-md-0 me-md-auto d-none">
                    <a href="/" className="link-body-emphasis text-decoration-none">
                        <svg className="bi me-2" width="40" height="32">
                        <use xlinkHref="#bootstrap"></use>
                        </svg>
                        {/* <span className="fs-4">Simple header</span> */}
                    </a>
                </Col>
                <Col className="d-flex justify-content-end align-items-center">                    
                    <Nav className="nav-pills-end">
                        
                        <Nav.Item className="align-items-center">
                            <Nav.Link
                                className="custom-nav-link nav-link"
                                // href="/"
                                onClick={() => onHeaderItemSelected("Home")}
                            >Home</Nav.Link>
                        </Nav.Item>
                        { isLogin && <Nav.Item className="align-items-center">
                            <Nav.Link
                                className="custom-nav-link"                                
                                onClick={() => onHeaderItemSelected("Pricing")}
                            >Pricing</Nav.Link>
                        </Nav.Item> }
                        {/* <Nav.Item className="align-items-center">
                            <Nav.Link className="custom-nav-link">About</Nav.Link>
                        </Nav.Item> */}
                        <Nav.Item>
                            <Button
                                variant="outline-success"
                                className="border-0 icon-1-2x d-none d-md-block"
                                onClick={onCheckLogin}
                            >
                                {isLogin ? (
                                    <i className="bi bi-person-check"></i>
                                ) : (
                                    <i className="bi bi-person"></i>
                                )}
                            </Button>
                        </Nav.Item>
                    </Nav>
                </Col>
            </Row>
        </Container>
      </header>
    );
}

export default Header;

